import React from 'react';

import QuestionsListPaginator from 'components/PracticeView/QuestionsListPaginator/QuestionsListPaginator.react';

interface Props {
  setActiveQuestionState: (question: any, questionSet: any) => void;
  scrollToQuestionById: React.RefObject<any>;
  paginatedQuestionsListManager: any;
  activeQuestion: any;
}

const QuestionsListFooter = ({
  setActiveQuestionState,
  scrollToQuestionById,
  paginatedQuestionsListManager,
  activeQuestion
}: Props) => {
  const activeQuestionSet = activeQuestion.getQuestionSet() || null;

  const currentPage = paginatedQuestionsListManager.getPageForId(activeQuestionSet.getId());

  const navigateAndScrollToPage = (pageNum) => {
    const firstSetOnPage = paginatedQuestionsListManager.getQuestionSetsInPage(pageNum).first();
    const firstQuestion = firstSetOnPage.getQuestions().first();
    setActiveQuestionState(firstQuestion, firstSetOnPage);
    scrollToQuestionById.current(firstSetOnPage.getId());
  };

  const handlePaginatorPreviousClick = async () => {
    const previousPage = paginatedQuestionsListManager.getPageForId(activeQuestionSet.getId()) - 1;
    if (!paginatedQuestionsListManager.hasFetchedPage(previousPage)) {
      await paginatedQuestionsListManager.fetchPreviousPage();
    }
    navigateAndScrollToPage(previousPage);
  };

  const handlePaginatorNextClick = async () => {
    const nextPage = paginatedQuestionsListManager.getPageForId(activeQuestionSet.getId()) + 1;
    if (!paginatedQuestionsListManager.hasFetchedPage(nextPage)) {
      await paginatedQuestionsListManager.fetchNextPage();
    }
    navigateAndScrollToPage(nextPage);
  };

  return (
    <QuestionsListPaginator
      currentPage={currentPage}
      isRequestInFlight={paginatedQuestionsListManager.isRequestInFlight}
      totalPages={paginatedQuestionsListManager.totalPages}
      isPreviousDisabled={paginatedQuestionsListManager.isRequestInFlight || currentPage === 1}
      isNextDisabled={
        paginatedQuestionsListManager.isRequestInFlight ||
        currentPage === paginatedQuestionsListManager.totalPages
      }
      handlePreviousPage={handlePaginatorPreviousClick}
      handleNextPage={handlePaginatorNextClick}
    />
  );
};

export default QuestionsListFooter;
